import React from 'react'
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro'
import i18n from 'config/i18n'
import { StringCell } from 'components/Shared/MuiTable/Cell/StringCell'
import { ActionTextCell } from 'components/Shared/MuiTable/Cell/RouteLinkCell'
import { BannerGroupState } from 'state/banners'

export interface RowsProps {
    id: string
    name: {
        value: string
    }
}

export const getColumns = (): GridColDef[] => {
    const cols: GridColDef[] = [
        {
            field: 'name',
            headerName: i18n.t('submission.table.bannerGroupNameLabel', 'Banner Group Name'),
            minWidth: 140,
            flex: 1,
            renderCell: (props: GridRenderCellParams) => <StringCell {...props} />,
            sortable: false,
        },
        {
            field: 'action',
            type: 'string',
            headerName: i18n.t('submission.table.actionsLabel'),
            width: 148,
            renderCell: (props: GridRenderCellParams) => <ActionTextCell {...props} />,
            sortable: false,
            filterable: false,
        },
    ]
    return cols
}

export const getRows = (bannerGroups: BannerGroupState[]): RowsProps[] => {
    return bannerGroups.map((bannerGroup: BannerGroupState) => {
        const url = `/banners/bannerList?bannerGroup=${bannerGroup.uuid}`
        return {
            id: bannerGroup.uuid,
            name: { value: bannerGroup.name },
            action: {
                url,
                actionTitle: i18n.t('button.viewBanners', 'View Banners'),
                dataTestId: 'test-action-text-cell-' + bannerGroup.country,
            },
        }
    })
}
